const T = {
  en: {
    shopNow: "Shop Now", addToCart: "Add to Cart", buyNow: "Buy Now",
    featured: "Featured Products", categories: "Shop by Category",
    freeShipping: "Free Shipping", freeShippingDesc: "On orders above ₹499",
    authentic: "100% Authentic", qualityTested: "Quality Tested",
    home: "Home", products: "All Products", about: "About", contact: "Contact",
    cart: "Cart", account: "Account", search: "Search",
    reviews: "Reviews", verifiedPurchase: "Verified Purchase",
    inStock: "In Stock", outOfStock: "Out of Stock",
    quantity: "Quantity", size: "Size / Weight",
    welcomeOffer: "Welcome Offer", limitedTime: "Limited Time Offer",
    whyChooseUs: "Why Choose Us", testimonials: "What Customers Say",
    newsletter: "Join Our Premium Club", subscribe: "Subscribe",
    needHelp: "Need Help Choosing?", expertAssistance: "Expert Assistance",
    viewAll: "View All Products", wishlist: "Wishlist",
    onlyLeft: "Only {n} left!", offerEnds: "Offer ends in",
    addMore: "Add ₹{n} more for FREE delivery!",
    freeDeliveryUnlocked: "🎉 You've unlocked FREE delivery!",
    shop: "Shop", explore: "Explore", giftHampers: "Gift Hampers",
    sourcingStory: "Sourcing Story", ourBlog: "Our Blog", trackOrder: "Track Order", faqs: "FAQs",
    myOrders: "My Orders", myProfile: "My Profile", adminDashboard: "Admin Dashboard", signOut: "Sign Out",
    login: "Login", loginRegister: "Login / Register", allProducts: "All Products",
    bestSellers: "Best Sellers", newArrivals: "New Arrivals", close: "Close",
    freeDeliveryBanner: "Free Delivery on Orders Above ₹499",
    fssaiBanner: "FSSAI Certified · Direct from Source Farms",
    yearsBanner: "25+ Years in Gangauri Bazar, Jaipur",
    searchBtn: "Search", searchPlaceholder: "Search almonds, cashews, gift hampers...",
    joinPremiumClub: "Join Our Premium Club", emailPlaceholder: "Your email address", subscribing: "Subscribing...",
    aboutUs: "About Us", contactUs: "Contact Us", shippingPolicy: "Shipping Policy",
    returnRefund: "Return & Refund", privacyPolicy: "Privacy Policy", termsConditions: "Terms & Conditions",
    weAccept: "We Accept",
    ourJourney: "Our Journey", whyChooseUsHome: "Why Choose Us", bulkOrdersEasy: "Bulk Orders, Made Easy",
    needHelpChoosing: "Need Help Choosing?", viewAllProducts: "View All Products", viewAllCombos: "View All Combos",
    viewAllArticles: "View All Articles", viewAllFaqs: "View All FAQs", readMore: "Read More", showLess: "Show Less",
  },
  hi: {
    shopNow: "अभी खरीदें", addToCart: "कार्ट में डालें", buyNow: "अभी लें",
    featured: "विशेष उत्पाद", categories: "श्रेणी चुनें",
    freeShipping: "मुफ़्त डिलीवरी", freeShippingDesc: "₹499 से ऊपर के ऑर्डर पर",
    authentic: "100% असली", qualityTested: "गुणवत्ता जांचा",
    home: "होम", products: "सभी उत्पाद", about: "हमारे बारे में", contact: "संपर्क",
    cart: "कार्ट", account: "अकाउंट", search: "खोजें",
    reviews: "समीक्षाएँ", verifiedPurchase: "सत्यापित खरीद",
    inStock: "स्टॉक में है", outOfStock: "स्टॉक नहीं",
    quantity: "मात्रा", size: "आकार / वजन",
    welcomeOffer: "स्वागत ऑफर", limitedTime: "सीमित समय का ऑफर",
    whyChooseUs: "हमें क्यों चुनें", testimonials: "ग्राहक क्या कहते हैं",
    newsletter: "हमारे प्रीमियम क्लब से जुड़ें", subscribe: "सदस्यता लें",
    needHelp: "सही उत्पाद चुनने में मदद चाहिए?", expertAssistance: "विशेषज्ञ सहायता",
    viewAll: "सभी उत्पाद देखें", wishlist: "पसंदीदा",
    onlyLeft: "केवल {n} बचा है!", offerEnds: "ऑफर खत्म होने में",
    addMore: "मुफ्त डिलीवरी के लिए ₹{n} और जोड़ें!",
    freeDeliveryUnlocked: "🎉 मुफ्त डिलीवरी मिल गई!",
    shop: "खरीदारी", explore: "एक्सप्लोर", giftHampers: "गिफ्ट हैम्पर्स",
    sourcingStory: "सोर्सिंग स्टोरी", ourBlog: "हमारा ब्लॉग", trackOrder: "ऑर्डर ट्रैक करें", faqs: "सामान्य प्रश्न",
    myOrders: "मेरे ऑर्डर", myProfile: "मेरी प्रोफाइल", adminDashboard: "एडमिन डैशबोर्ड", signOut: "साइन आउट",
    login: "लॉगिन", loginRegister: "लॉगिन / रजिस्टर", allProducts: "सभी उत्पाद",
    bestSellers: "बेस्ट सेलर्स", newArrivals: "नई आवक", close: "बंद करें",
    freeDeliveryBanner: "₹499 से ऊपर के ऑर्डर पर मुफ़्त डिलीवरी",
    fssaiBanner: "FSSAI प्रमाणित · सीधे स्रोत फार्म से",
    yearsBanner: "गंगौरी बाज़ार, जयपुर में 25+ वर्ष",
    searchBtn: "खोजें", searchPlaceholder: "बादाम, काजू, गिफ्ट हैम्पर्स खोजें...",
    joinPremiumClub: "हमारे प्रीमियम क्लब से जुड़ें", emailPlaceholder: "आपका ईमेल पता", subscribing: "सदस्यता ली जा रही है...",
    aboutUs: "हमारे बारे में", contactUs: "संपर्क करें", shippingPolicy: "शिपिंग नीति",
    returnRefund: "रिटर्न और रिफंड", privacyPolicy: "गोपनीयता नीति", termsConditions: "नियम व शर्तें",
    weAccept: "हम स्वीकार करते हैं",
  },
  mr: {
    shopNow: "आता खरेदी करा", addToCart: "कार्टमध्ये टाका", buyNow: "आता घ्या",
    featured: "विशेष उत्पादने", categories: "श्रेणी निवडा",
    freeShipping: "मोफत डिलीव्हरी", freeShippingDesc: "₹499 वरील ऑर्डरवर",
    authentic: "100% शुद्ध", qualityTested: "गुणवत्ता तपासलेली",
    home: "होम", products: "सर्व उत्पादने", about: "आमच्याबद्दल", contact: "संपर्क",
    cart: "कार्ट", account: "खाते", search: "शोधा",
    reviews: "पुनरावलोकने", verifiedPurchase: "सत्यापित खरेदी",
    inStock: "साठ्यात आहे", outOfStock: "साठा नाही",
    quantity: "प्रमाण", size: "आकार / वजन",
    welcomeOffer: "स्वागत ऑफर", limitedTime: "मर्यादित वेळेची ऑफर",
    whyChooseUs: "आम्हाला का निवडा", testimonials: "ग्राहक काय म्हणतात",
    newsletter: "आमच्या प्रीमियम क्लबमध्ये सामील व्हा", subscribe: "सदस्यता घ्या",
    needHelp: "योग्य उत्पाद निवडण्यात मदत हवी?", expertAssistance: "तज्ञ मदत",
    viewAll: "सर्व उत्पादने पहा", wishlist: "आवडते",
    onlyLeft: "फक्त {n} उरले!", offerEnds: "ऑफर संपण्यापूर्वी",
    addMore: "मोफत डिलीव्हरीसाठी आणखी ₹{n} जोडा!",
    freeDeliveryUnlocked: "🎉 मोफत डिलीव्हरी मिळाली!",
    shop: "खरेदी", explore: "एक्सप्लोर", giftHampers: "गिफ्ट हॅम्पर्स",
    sourcingStory: "सोर्सिंग स्टोरी", ourBlog: "आमचा ब्लॉग", trackOrder: "ऑर्डर ट्रॅक करा", faqs: "सामान्य प्रश्न",
    myOrders: "माझ्या ऑर्डर्स", myProfile: "माझी प्रोफाइल", adminDashboard: "अ‍ॅडमिन डॅशबोर्ड", signOut: "साइन आउट",
    login: "लॉगिन", loginRegister: "लॉगिन / नोंदणी", allProducts: "सर्व उत्पादने",
    bestSellers: "बेस्ट सेलर्स", newArrivals: "नवीन आगमन", close: "बंद करा",
    freeDeliveryBanner: "₹499 वरील ऑर्डरवर मोफत डिलिव्हरी",
    fssaiBanner: "FSSAI प्रमाणित · थेट स्रोत फार्मवरून",
    yearsBanner: "गंगौरी बाजार, जयपूरमध्ये 25+ वर्षे",
    searchBtn: "शोधा", searchPlaceholder: "बदाम, काजू, गिफ्ट हॅम्पर्स शोधा...",
    joinPremiumClub: "आमच्या प्रीमियम क्लबमध्ये सामील व्हा", emailPlaceholder: "तुमचा ईमेल पत्ता", subscribing: "सदस्यता घेतली जात आहे...",
    aboutUs: "आमच्याबद्दल", contactUs: "संपर्क साधा", shippingPolicy: "शिपिंग धोरण",
    returnRefund: "परतावा आणि रिफंड", privacyPolicy: "गोपनीयता धोरण", termsConditions: "नियम व अटी",
    weAccept: "आम्ही स्वीकारतो",
  },
  gu: {
    shopNow: "હવે ખરીદો", addToCart: "કાર્ટમાં ઉમેરો", buyNow: "હવે ખરીદો",
    featured: "વિશેષ ઉત્પાદનો", categories: "શ્રેણી પસંદ કરો",
    freeShipping: "મફત ડિલિવરી", freeShippingDesc: "₹499 ઉપરના ઓર્ડર પર",
    authentic: "100% અસ્સલ", qualityTested: "ગુણવત્તા ચકાસેલ",
    home: "હોમ", products: "બધા ઉત્પાદનો", about: "અમારા વિશે", contact: "સંપર્ક",
    cart: "કાર્ટ", account: "એકાઉન્ટ", search: "શોધો",
    reviews: "સમીક્ષાઓ", verifiedPurchase: "ચકાસાયેલ ખરીદી",
    inStock: "સ્ટોકમાં છે", outOfStock: "સ્ટોક નથી",
    quantity: "જથ્થો", size: "કદ / વજન",
    welcomeOffer: "સ્વાગત ઓફર", limitedTime: "મર્યાદિત સમયની ઓફર",
    whyChooseUs: "અમને શા માટે પસંદ કરો", testimonials: "ગ્રાહકો શું કહે છે",
    newsletter: "અમારા પ્રીમિયમ ક્લબમાં જોડાઓ", subscribe: "સભ્ય બનો",
    needHelp: "યોગ્ય ઉત્પાદ પસંદ કરવામાં મદદ જોઈએ?", expertAssistance: "નિષ્ણાત સહાય",
    viewAll: "બધા ઉત્પાદનો જુઓ", wishlist: "પ્રિય",
    onlyLeft: "માત્ર {n} બાકી!", offerEnds: "ઓફર સમાપ્ત થાય છે",
    addMore: "મફત ડિલિવરી માટે ₹{n} વધુ ઉમેરો!",
    freeDeliveryUnlocked: "🎉 મફત ડિલિવરી મળ્યું!",
    shop: "શોપ", explore: "એક્સપ્લોર", giftHampers: "ગિફ્ટ હેમ્પર્સ",
    sourcingStory: "સોર્સિંગ સ્ટોરી", ourBlog: "અમારો બ્લોગ", trackOrder: "ઓર્ડર ટ્રેક કરો", faqs: "વારંવાર પુછાતા પ્રશ્નો",
    myOrders: "મારા ઓર્ડર્સ", myProfile: "મારી પ્રોફાઇલ", adminDashboard: "એડમિન ડેશબોર્ડ", signOut: "સાઇન આઉટ",
    login: "લોગિન", loginRegister: "લોગિન / રજિસ્ટર", allProducts: "બધા ઉત્પાદનો",
    bestSellers: "બેસ્ટ સેલર્સ", newArrivals: "નવા આગમન", close: "બંધ કરો",
    freeDeliveryBanner: "₹499 ઉપરના ઓર્ડર પર મફત ડિલિવરી",
    fssaiBanner: "FSSAI પ્રમાણિત · સીધા સ્ત્રોત ફાર્મમાંથી",
    yearsBanner: "ગંગૌરી બજાર, જયપુરમાં 25+ વર્ષ",
    searchBtn: "શોધો", searchPlaceholder: "બદામ, કાજુ, ગિફ્ટ હેમ્પર્સ શોધો...",
    joinPremiumClub: "અમારા પ્રીમિયમ ક્લબમાં જોડાઓ", emailPlaceholder: "તમારું ઇમેઇલ સરનામું", subscribing: "સબ્સ્ક્રાઇબ થઈ રહ્યું છે...",
    aboutUs: "અમારા વિશે", contactUs: "અમારો સંપર્ક કરો", shippingPolicy: "શિપિંગ નીતિ",
    returnRefund: "રિટર્ન અને રિફંડ", privacyPolicy: "ગોપનીયતા નીતિ", termsConditions: "નિયમો અને શરતો",
    weAccept: "અમે સ્વીકારીએ છીએ",
  },
  ta: {
    shopNow: "இப்போது வாங்கு", addToCart: "கார்ட்டில் சேர்", buyNow: "இப்போது வாங்கு",
    featured: "சிறப்பு தயாரிப்புகள்", categories: "வகை தேர்ந்தெடு",
    freeShipping: "இலவச டெலிவரி", freeShippingDesc: "₹499க்கு மேல் ஆர்டர்களுக்கு",
    authentic: "100% தூய்மையான", qualityTested: "தரம் சோதிக்கப்பட்டது",
    home: "முகப்பு", products: "அனைத்து தயாரிப்புகள்", about: "பற்றி", contact: "தொடர்பு",
    cart: "கார்ட்", account: "கணக்கு", search: "தேடு",
    reviews: "விமர்சனங்கள்", verifiedPurchase: "சரிபார்க்கப்பட்ட கொள்முதல்",
    inStock: "கையிருப்பில் உள்ளது", outOfStock: "கையிருப்பில் இல்லை",
    quantity: "அளவு", size: "அளவு / எடை",
    welcomeOffer: "வரவேற்பு சலுகை", limitedTime: "வரையறுக்கப்பட்ட நேர சலுகை",
    whyChooseUs: "ஏன் எங்களை தேர்ந்தெடுக்க வேண்டும்", testimonials: "வாடிக்கையாளர்கள் கூறுவது",
    newsletter: "எங்கள் பிரீமியம் கிளப்பில் சேரு", subscribe: "சந்தா",
    needHelp: "சரியான தயாரிப்பு தேர்ந்தெடுக்க உதவி வேண்டுமா?", expertAssistance: "நிபுணர் உதவி",
    viewAll: "அனைத்து தயாரிப்புகளையும் பார்க்கவும்", wishlist: "விருப்பப்பட்டியல்",
    onlyLeft: "வெறும் {n} மட்டுமே!", offerEnds: "சலுகை முடிவடைகிறது",
    addMore: "இலவச டெலிவரிக்கு ₹{n} மேலும் சேர்க்கவும்!",
    freeDeliveryUnlocked: "🎉 இலவச டெலிவரி கிடைத்தது!",
    shop: "ஷாப்", explore: "எக்ஸ்ப்ளோர்", giftHampers: "பரிசு பெட்டிகள்",
    sourcingStory: "சோர்சிங் கதை", ourBlog: "எங்கள் வலைப்பதிவு", trackOrder: "ஆர்டர் கண்காணி", faqs: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    myOrders: "எனது ஆர்டர்கள்", myProfile: "எனது சுயவிவரம்", adminDashboard: "நிர்வாக டாஷ்போர்டு", signOut: "வெளியேறு",
    login: "உள்நுழை", loginRegister: "உள்நுழை / பதிவு செய்", allProducts: "அனைத்து தயாரிப்புகள்",
    bestSellers: "சிறந்த விற்பனையாளர்கள்", newArrivals: "புதிய வரவுகள்", close: "மூடு",
    freeDeliveryBanner: "₹499க்கு மேல் ஆர்டர்களுக்கு இலவச டெலிவரி",
    fssaiBanner: "FSSAI சான்றளிக்கப்பட்டது · நேரடி பண்ணையிலிருந்து",
    yearsBanner: "கங்கௌரி பஜார், ஜெய்ப்பூரில் 25+ ஆண்டுகள்",
    searchBtn: "தேடு", searchPlaceholder: "பாதாம், முந்திரி, பரிசு பெட்டிகள் தேடு...",
    joinPremiumClub: "எங்கள் பிரீமியம் கிளப்பில் சேரு", emailPlaceholder: "உங்கள் மின்னஞ்சல் முகவரி", subscribing: "சந்தா செய்யப்படுகிறது...",
    aboutUs: "எங்களைப் பற்றி", contactUs: "எங்களை தொடர்பு கொள்ள", shippingPolicy: "டெலிவரி கொள்கை",
    returnRefund: "திரும்பப் பெறுதல் & பணத்திரும்பல்", privacyPolicy: "தனியுரிமைக் கொள்கை", termsConditions: "விதிமுறைகள் & நிபந்தனைகள்",
    weAccept: "நாங்கள் ஏற்கிறோம்",
  },
  bn: {
    shopNow: "এখন কিনুন", addToCart: "কার্টে যোগ করুন", buyNow: "এখন কিনুন",
    featured: "বিশেষ পণ্য", categories: "বিভাগ বেছে নিন",
    freeShipping: "বিনামূল্যে ডেলিভারি", freeShippingDesc: "₹499-এর উপরে অর্ডারে",
    authentic: "100% খাঁটি", qualityTested: "মান পরীক্ষিত",
    home: "হোম", products: "সব পণ্য", about: "আমাদের সম্পর্কে", contact: "যোগাযোগ",
    cart: "কার্ট", account: "অ্যাকাউন্ট", search: "খুঁজুন",
    reviews: "পর্যালোচনা", verifiedPurchase: "যাচাইকৃত ক্রয়",
    inStock: "স্টকে আছে", outOfStock: "স্টক নেই",
    quantity: "পরিমাণ", size: "আকার / ওজন",
    welcomeOffer: "স্বাগত অফার", limitedTime: "সীমিত সময়ের অফার",
    whyChooseUs: "কেন আমাদের বেছে নেবেন", testimonials: "গ্রাহকরা কী বলছেন",
    newsletter: "আমাদের প্রিমিয়াম ক্লাবে যোগ দিন", subscribe: "সাবস্ক্রাইব করুন",
    needHelp: "সঠিক পণ্য বেছে নিতে সাহায্য দরকার?", expertAssistance: "বিশেষজ্ঞ সহায়তা",
    viewAll: "সব পণ্য দেখুন", wishlist: "পছন্দের তালিকা",
    onlyLeft: "মাত্র {n}টি বাকি!", offerEnds: "অফার শেষ হচ্ছে",
    addMore: "বিনামূল্যে ডেলিভারির জন্য ₹{n} আরো যোগ করুন!",
    freeDeliveryUnlocked: "🎉 বিনামূল্যে ডেলিভারি পেয়েছেন!",
    shop: "শপ", explore: "এক্সপ্লোর", giftHampers: "গিফট হ্যাম্পার",
    sourcingStory: "সোর্সিং স্টোরি", ourBlog: "আমাদের ব্লগ", trackOrder: "অর্ডার ট্র্যাক করুন", faqs: "সাধারণ প্রশ্ন",
    myOrders: "আমার অর্ডার", myProfile: "আমার প্রোফাইল", adminDashboard: "অ্যাডমিন ড্যাশবোর্ড", signOut: "সাইন আউট",
    login: "লগইন", loginRegister: "লগইন / নিবন্ধন", allProducts: "সব পণ্য",
    bestSellers: "বেস্ট সেলার", newArrivals: "নতুন সংগ্রহ", close: "বন্ধ করুন",
    freeDeliveryBanner: "₹499-এর উপরে অর্ডারে বিনামূল্যে ডেলিভারি",
    fssaiBanner: "FSSAI প্রত্যয়িত · সরাসরি উৎস খামার থেকে",
    yearsBanner: "গাঙ্গৌরি বাজার, জয়পুরে ২৫+ বছর",
    searchBtn: "খুঁজুন", searchPlaceholder: "বাদাম, কাজু, গিফট হ্যাম্পার খুঁজুন...",
    joinPremiumClub: "আমাদের প্রিমিয়াম ক্লাবে যোগ দিন", emailPlaceholder: "আপনার ইমেল ঠিকানা", subscribing: "সাবস্ক্রাইব করা হচ্ছে...",
    aboutUs: "আমাদের সম্পর্কে", contactUs: "যোগাযোগ করুন", shippingPolicy: "শিপিং নীতি",
    returnRefund: "রিটার্ন ও রিফান্ড", privacyPolicy: "গোপনীয়তা নীতি", termsConditions: "শর্তাবলী",
    weAccept: "আমরা গ্রহণ করি",
  },
};

export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "हि", name: "हिंदी" },
  { code: "mr", label: "म", name: "मराठी" },
  { code: "gu", label: "ગુ", name: "ગુજરાતી" },
  { code: "ta", label: "த", name: "தமிழ்" },
  { code: "bn", label: "বা", name: "বাংলা" },
];

export function t(lang, key, vars = {}) {
  let str = T[lang]?.[key] || T.en[key] || key;
  Object.entries(vars).forEach(([k, v]) => { str = str.replace(`{${k}}`, v); });
  return str;
}

export default T;
